import DispalyImage from 'components/wrapperComponents/DispalyImage';
import { msgTypes } from 'constants/msgTypes';
import { InvoiceManagementModel } from 'model/screensModels/InvoiceManagementModel';
import { useEffect, useState } from 'react';
import { LocalStorageService } from 'services/auth/LocalStorageService';
import { InvoiceManagementService } from 'services/menu/invoiceManagementService/InvoiceManagementService';
import ApiUrl from 'services/shared/ApiUrl';

const DisplayParticularInvoiceAsDrawer = ({ selectedInvoice, setOpen }) => {
    const [loginCompanyId, setLoginCompanyId] = useState("");

    useEffect(()=>{
        getLoginCompanyDetails();
    },[])

    const getLoginCompanyDetails = async() =>{
        const loginCompanyDetails = JSON.parse(await  LocalStorageService.getUserDetails());
        setLoginCompanyId(loginCompanyDetails.companyId);
    }

    const readQuotes = async (row: InvoiceManagementModel) => {
        const requestData = new InvoiceManagementModel();
        requestData.invoiceId = row.invoiceId;
        const response = await InvoiceManagementService.invoiceMarkAsRead(requestData);
        if (response.statusMsg === msgTypes.SUCCESS.msg) {
            setOpen(false)
        }
    }

    const formatNumber = (number) => {
        return new Intl.NumberFormat('en-IN').format(number);
      };
    

   
    return (
        <>
            <div className='list-popup'>
                <ul className="list-group">
                    <li className="list-group-item border-0 d-flex p-4 bg-gray-100 border-radius-lg">
                        <div className="d-flex flex-column">
                            <h6 className="mb-3 text-sm">Invoice</h6>
                            <span className="mb-2 text-xs">Invoice Number : <span className="text-dark font-weight-bold ms-2">{selectedInvoice.invoiceId}</span></span>
                            <span className="mb-2 text-xs">Sender Company : <span className="text-dark font-weight-bold ms-2">{selectedInvoice.fromCompanyName}</span></span>
                            <span className="mb-2 text-xs">Receiver Company : <span className="text-dark ms-2 font-weight-bold">{selectedInvoice.toCompanyName}</span></span>
                            <span className="mb-2 text-xs">Ammount :<span className="text-dark ms-2 font-weight-bold">{formatNumber(selectedInvoice.amount)}</span></span>
                            <span className="mb-2 text-xs">Currency :<span className="text-dark ms-2 font-weight-bold">{selectedInvoice.currency}</span></span>
                            <span className="mb-2 text-xs">Invoice Uploaded on :<span className="text-dark ms-2 font-weight-bold">{selectedInvoice.uploadingDate}</span></span>
                            <span className="mb-2 text-xs">Invoice Expire on :<span className="text-dark ms-2 font-weight-bold">{selectedInvoice.dueDate}</span></span>
                            <span className="mb-2 text-xs">Subject :<span className="text-dark ms-2 font-weight-bold">{selectedInvoice.subject}</span></span>
                            <span className="mb-2 text-xs">Status :<span className="text-dark ms-2 font-weight-bold">{selectedInvoice.status}</span></span>

                        </div>
                    </li>
                </ul>
            </div>


            <div className='list-popup'>
                <ul className="list-group">
                    {selectedInvoice.bankDetails && selectedInvoice.bankDetails.length > 0 ?
                        <li className="list-group-item border-0 d-flex p-4 bg-gray-100 border-radius-lg mb-3">
                            <div className="d-flex flex-column">
                                <h6 className="mb-3 text-sm">Bank Details</h6>
                                <span className="mb-2 text-xs">Account Holder Name : <span className="text-dark font-weight-bold ms-2">{selectedInvoice.bankDetails[0].accountHolderName}</span></span>
                                <span className="mb-2 text-xs">Account Number : <span className="text-dark ms-2 font-weight-bold">{selectedInvoice.bankDetails[0].accountNumber}</span></span>
                                <span className="mb-2 text-xs">Bank Name :<span className="text-dark ms-2 font-weight-bold">{selectedInvoice.bankDetails[0].bankName}</span></span>
                                <span className="mb-2 text-xs">Branch Name :<span className="text-dark ms-2 font-weight-bold">{selectedInvoice.bankDetails[0].branchName}</span></span>
                                <span className="mb-2 text-xs">Currency :<span className="text-dark ms-2 font-weight-bold">{selectedInvoice.currency}</span></span>
                            </div>
                        </li>
                        : ""}
                    <li className="list-group-item uploaded-invoice border-0 d-flex p-4 bg-gray-100 border-radius-lg">
                        <span className="mb-2 text-xs">Uploaded Invoice :<span className="text-dark ms-2 font-weight-bold"><br/>
                            <a href={ApiUrl.fileBaseUrl + selectedInvoice?.uploadedInvoice} target='_blank'>
                                <DispalyImage
                                    imageUrl={selectedInvoice?.uploadedInvoice}
                                    imageSize={msgTypes.IMAGE_SIZE.SMALL} />
                            </a>
                        </span>

                        </span>
                    </li>
                </ul>
            </div>

            <div className='row px-3 pt-4'>
                { (loginCompanyId===selectedInvoice.toCompanyId && !selectedInvoice.toReadStatus)  && (
                    <button className='btn btn-submit text-white w-100' onClick={() => { readQuotes(selectedInvoice) }}>Accept</button>
                )}
            </div>
        </>
    )
}

export default DisplayParticularInvoiceAsDrawer